export const TransEn = {
  title: "Help protect your future and the ones you love with life insurance",
  subTitle:
    "American Fidelity International Ltd. may help provide peace of mind and security with personalized coverage. Meet with us today.",
  learnMore: "Scroll to Learn More",
};

export const TransEs = {
  title:
    "Ayude a proteger tu futuro y el de tus seres queridos con un seguro de vida",
  subTitle:
    "American Fidelity International Ltd. puede ayudar a brindar tranquilidad y seguridad con una cobertura personalizada. Reúnase con nosotros hoy mismo.",
  learnMore: "Desplácese para obtener más información",
};

export const TransPu = {
  title:
    "Ajude a proteger seu futuro e aqueles que você ama com um seguro de vida",
  subTitle:
    "A American Fidelity International Ltd. pode ajudar a oferecer tranquilidade e segurança com uma cobertura personalizada. Fale conosco hoje mesmo.",
  learnMore: "Role para Saber Mais",
};
